module.exports = __webpack_public_path__ + "static/media/2.2 Heeremans waehrend FA.f5d8a85a.jpg";